export const MAX_RUPEES = 100000000;
export const MONTHLY_IDS = ["missing-offer", "leads-short", "gut-decisions", "funnel-stages", "common-gaps", "mri-low", "no-pipeline", "invisible"];
export const normalizeMoney = (value) => String(value ?? "").replace(/[\s,₹]/g, "");
export const rupees = (value) => `₹${Number(value).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export function parseMoney(raw) {
  const text = normalizeMoney(raw);
  if (text === "") return { value: null, error: null };
  if (!/^[0-9]+$/.test(text)) return { value: null, error: "Enter a whole number in ₹" };
  const value = Number(text);
  if (value > MAX_RUPEES) return { value: null, error: "Maximum amount is ₹10,00,00,000" };
  return { value, error: null };
}

// Single calculation path for hydrated saved data and immediate drafts. No stored estimates.
// Max input × bounded configuration multiplier × 8 × 12 is below Number.MAX_SAFE_INTEGER.
export function calculateAudit(config, records) {
  const rows = {};
  const grand = { cost: 0, growth: 0, count: 0 };
  config.rows.filter((rule) => MONTHLY_IDS.includes(rule.id)).forEach((rule) => {
    const amount = parseMoney(records[rule.id]?.amount).value;
    const growth = amount === null ? null : amount * rule.multiplier;
    rows[rule.id] = { amount, growth, unlocked: amount !== null };
    if (amount !== null) {
      grand.cost += amount; grand.growth += growth; grand.count += 1;
    }
  });
  return { rows, grand };
}